const SELL_DOCUMENT_TYPE_DESCRIPTIONS: Record<number, string> = {
  30: 'Factura',
  32: 'Factura de ventas y servicios no afectos o exentos de IVA',
  33: 'Factura Electrónica',
  34: 'Factura no Afecta o Exenta Electrónica',
  35: 'Total operaciones del mes, con boleta (afecta)',
  38: 'Total operaciones del mes con boleta no afecta o exenta',
  39: 'Total operaciones del mes, con boleta electrónica',
  40: 'Liquidación factura',
  41: 'Total operaciones del mes, con boleta no afecta o exenta electrónica',
  43: 'Liquidación-Factura Electrónica',
  45: 'Factura de Compra',
  46: 'Factura de Compra electrónica',
  55: 'Nota de débito',
  56: 'Nota de débito electrónica',
  60: 'Nota de Crédito',
  61: 'Nota de crédito electrónica',
  101: 'Factura de exportación',
  102: 'Factura de venta exenta a zona franca primaria',
  103: 'Liquidación',
  104: 'Nota de débito de exportación',
  105: 'Boleta liquidación',
  106: 'Nota de Crédito de exportación',
  108: 'SRF Solicitud Registro de Factura',
  109: 'Factura a turista',
  110: 'Factura de Exportación Electrónica',
  111: 'Nota de Débito de Exportación Electrónica',
  112: 'Nota de Crédito de Exportación Electrónica',
  901: 'Factura de ventas a empresas del territorio preferencial',
  902: 'Conocimiento de Embarque',
  903: 'Documento único de Salida',
  919: 'Resumen ventas de nacionales pasajes sin Factura',
  920: 'Otros registros no documentados Aumenta débito',
  922: 'Otros registros. Disminuye débito',
  924: 'Resumen ventas de internacionales pasajes sin Factura',
};

export { SELL_DOCUMENT_TYPE_DESCRIPTIONS };
